export default {"src":"/_next/static/media/Withdraw-anytime.510a8759.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};